module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password-input auth-login-page"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [(_vm.onMobile) ? _c('div', {
    staticClass: "form-icon"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/mail_icon_outline.svg'),
      "alt": "main icon"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " my-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email'),
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn py-3",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("\n      Reset Password\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "\n        text-xs-center\n        mt-3\n        dflex\n        align-center\n        justify-center\n      "
  }, [_c('span', {
    staticClass: "terms-text mr-2 cursor-pointer app-bold",
    on: {
      "click": function($event) {
        !_vm.showLogin ? _vm.$route.push('/login') : _vm.showLogin()
      }
    }
  }, [_vm._v("\n        Back to login\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee94af60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/forgotPasswordInput.vue
// module id = 1866
// module chunks = 180